import React from "react";
import { Range } from "../comp/Range";
import { Icon } from "../comp/Icon";

export class Editor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 1
        };

        this.changeStep = this.changeStep.bind(this);
        this.resetStep = this.resetStep.bind(this);

        this.boolToggle = this.boolToggle.bind(this);
        this.resetPosition = this.resetPosition.bind(this);
        this.moveY = this.moveY.bind(this);
        this.moveX = this.moveX.bind(this);
        this.rotate = this.rotate.bind(this);
    }

    componentDidMount() {
        document.addEventListener("keydown", this.changeStep, false);
        document.addEventListener("keyup", this.resetStep, false);
    }


    changeStep(e) {
        // change step (+1 or +10) depending on if shift key is held
        if(e.which == 16 || e.code == "ShiftLeft" || e.code == "ShiftRight") {
            this.setState({ step: 10 });
        }
        else if(e.which == 17 || e.code == "ControlLeft" || e.code == "ControlRight") {
            this.setState({ step: 20 });
        }
    }

    resetStep(e) {
        // change step (+1 or +10) depending on if shift key is held
        if(e.which == 16 || e.code == "ShiftLeft" || e.code == "ShiftRight" || e.which == 17 || e.code == "ControlLeft" || e.code == "ControlRight") {
            this.setState({ step: 1 });
        }
    }


    boolToggle(e) {
        // toggle boolean
        var item = this.props.activeItem[e.target.name];

        this.props.edit(this.props.index, e.target.name, !item);
    }

    resetPosition() {
        // reset xOffset, yOffset, Scale and Rotation
        this.props.edit(this.props.index, "xOffset", 0);
        this.props.edit(this.props.index, "yOffset", 0);
        this.props.edit(this.props.index, "rotation", 0);
    }

    moveY(e) {
        // move up / down
        var currentY = this.props.activeItem.yOffset,
            newY = currentY;


        if(e.target.name == "up") {
            // up
            newY = currentY - this.state.step;
        }
        else if(e.target.name == "down") {
            // down
            newY = currentY + this.state.step;
        }

        this.props.edit(this.props.index, "yOffset", newY);
    }

    moveX(e) {
        // move up / down
        var currentX = this.props.activeItem.xOffset,
            newX = currentX;


        // direction
        if(e.target.name == "left") {
            // left
            newX = currentX - this.state.step;
        }
        else if(e.target.name == "right") {
            // right
            newX = currentX + this.state.step;
        }

        this.props.edit(this.props.index, "xOffset", newX);
    }

    rotate(e) {
        // rotate
        var currentRot = this.props.activeItem.rotation,
            newRot = currentRot;


        // direction
        if(e.target.name == "clock") {
            // counter-clockwise
            if(currentRot - this.state.step < 0) {
                newRot = 360 - (currentRot + this.state.step);
            }
            else {
                newRot = currentRot - this.state.step;
            }
        }
        else if(e.target.name == "counterclock") {
            // clockwise
            if(currentRot + this.state.step >= 360) {
                newRot = currentRot + this.state.step - 360;
            }
            else {
                newRot = currentRot + this.state.step;
            }
        }
        
        this.props.edit(this.props.index, "rotation", newRot);
    }


    render() {
        return (
            <div className={this.props.options} onKeyPress={this.changeStep} onKeyUp={this.changeStep}>
                <div className="multiplier">
                    <span>
                        {(this.state.step == 1) ? <b>></b> : ">"}
                    </span>

                    <span className="give-tooltip" data-tooltip="SHIFT">
                        {(this.state.step == 10) ? <b>>></b> : ">>"}
                    </span>

                    <span className="give-tooltip" data-tooltip="CTRL">
                        {(this.state.step == 20) ? <b>>>></b> : ">>>"}
                    </span>
                </div>

                <button name="counterclock" onClick={this.rotate}> <Icon type="fa-undo" /> </button>
                <button name="up" onClick={this.moveY}> <Icon type="fa-chevron-up" /> </button>
                <button name="clock" onClick={this.rotate}> <Icon type="fa-undo hflip" /> </button>
                
                <span className="divider"></span>

                <button name="left" onClick={this.moveX}> <Icon type="fa-chevron-left" /> </button>

                <button onClick={this.resetPosition} className="give-tooltip" data-tooltip="Reset position">
                    <Icon type="fa-circle small" /> 
                </button>

                <button name="right" onClick={this.moveX}> <Icon type="fa-chevron-right" /> </button>

                <span className="divider"></span>

                <button name="hFlip" onClick={this.boolToggle}className="give-tooltip" data-tooltip="Flip horizontally"> 
                    <Icon type="fa-arrows-h" /> 
                </button>

                <button name="down" onClick={this.moveY}> <Icon type="fa-chevron-down" /> </button>

                <button name="vFlip" onClick={this.boolToggle}className="give-tooltip" data-tooltip="Flip vertically"> 
                    <Icon type="fa-arrows-v" /> 
                </button>

                <Range 
                    min="0.1" max="2" step="0.1" 
                    name="scale-slider" 
                    value={this.props.activeItem.scale} 
                    edit={this.props.edit}
                    index={this.props.index}
                />
            </div>
        );
    }
}


Editor.defaultProps = {
    activeItem: {
        scale: 1
    }
};
